export const BASE_ROUTES = {
	ACCESS_AUDIT: 'access-audit',
	ACCESS_COMPARISON: 'access-comparison',
	ACCESS_EXPLAINER: 'access-explainer',
	ADD_APP: 'add-app',
	ADMIN: 'admin',
	API_VOLUME: 'api-volume',
	APPLICATION_SETUP: 'application-setup',
	ARCHIVED: 'archived',
	CONFIRM: 'confirm',
	CONFIRM_LINK: 'confirmLink',
	CONNECT: 'connect',
	DASHBOARD: 'dashboard',
	DATA_ACCESS: 'data-access',
	DATA_DICTIONARY: 'data-dictionary',
	DATA_DICTIONARY_API_KEYS: 'data-dictionary-api-keys',
	DATA_SECURITY: 'data-security',
	EXPORT: 'export',
	FORGOT_PASSWORD: 'forgot-password',
	GOOGLE: 'google',
	INITIATIVES: 'initiatives',
	INTEGRATIONS: 'integrations',
	INVITATION: 'acceptInvitation',
	ISSUES: 'issues',
	JIRA: 'jira',
	LOGIN: 'login',
	MANAGE: 'manage',
	MONITORS: 'monitors',
	OIDC: 'oidc',
	OKTA: 'okta',
	ONBOARDING: 'onboarding',
	ORGANIZATION: 'organization',
	OUTREACH: 'outreach',
	PERISCOPE: 'periscope',
	RESET_PASSWORD: 'reset-password',
	SALESFORCE: 'salesforce',
	SALESLOFT: 'salesloft',
	SELECT_ORGANIZTION: 'select-organization',
	SETTINGS: 'settings',
	SETUP_AUDIT_TRAIL: 'setup-audit-trail',
	SHARED_VIEW: 'shared-view',
	SIGN_UP: 'sign-up',
	SLACK: 'slack',
	SNOOZED: 'snoozed',
	SYNC: 'sync',
	TAGS: 'tags',
	TEAM: 'team',
	TIMELINE: 'timeline',
	TOKEN: 'token',
	USER: 'user',
	USERS: 'users'
};
